import React, { useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { RouteEnum } from "core/enum/route.enum";
import "./LibraryItem.scss";

const LibraryItem = ({ image, title, bookData, id }) => {
  const history = useHistory();
  const titleRef = useRef(null);

  const handleClick = () => {
    // history.push({
    //   pathname: `/library/${id}`,
    //   state: { book: bookData },
    // });
    history.push({
      pathname: RouteEnum.LibraryDetail.replace(":id", String(id)),
      state: { book: bookData },
    });
  };

  useEffect(() => {
    const titleEl = titleRef.current;

    if (!titleEl) return;

    const textWidth = titleEl.scrollWidth;
    const containerWidth = titleEl.clientWidth;

    if (textWidth <= containerWidth) return;

    const distance = textWidth - containerWidth;

    const speed = 50;
    const duration = distance / speed;

    titleEl.style.setProperty("--move", `${distance}px`);
    titleEl.style.setProperty("--duration", `${duration}s`);
  }, [title]);

  return (
    <Card className="library-card-item" onClick={handleClick}>
      <div className="library-flash-card-img">
        <img
          src={`${process.env.REACT_APP_PUBLIC_PATH}/${image}`}
          alt={title}
        />

        <div className="library-dim-bg">
          <h2 ref={titleRef}>{title}</h2>
        </div>
      </div>
    </Card>
  );
};

export default LibraryItem;
